// zIndex
export const zIndexConfig = {
    // Notifications
    notification: 10000,
};
